import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["chartType", "keySelector", "keyMissingMessage"];

  connect() {
    this.updateFormState();
  }

  handleChartTypeChange() {
    this.updateFormState();
  }

  updateFormState() {
    if (!this.hasChartTypeTarget) return;

    const chartType = this.chartTypeTarget.value;
    
    // If lyrics is selected, hide the key selector since it's not needed for lyrics
    if (chartType === "lyrics") {
      if (this.hasKeySelectorTarget) {
        this.keySelectorTarget.classList.add("hidden");
      }
    } else {
      // For chord charts, show the key selector
      if (this.hasKeySelectorTarget) {
        this.keySelectorTarget.classList.remove("hidden");
      }
    }
  }
}